export const isValidZipRegex = (zip: string) => {
  return new RegExp('^[0-9]{5}(?:-?[0-9]{4})?$').test(zip);
};

export const transformZipInputValue = (inputValue: string) => {
  return inputValue.toString().replace(/\D/g, '').slice(0, 5).padEnd(5, '_');
};
